import { render, staticRenderFns } from "./DiscountSaleVip.vue?vue&type=template&id=ed47bec8&scoped=true&"
import script from "./DiscountSaleVip.vue?vue&type=script&lang=ts&"
export * from "./DiscountSaleVip.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountSaleVip.vue?vue&type=style&index=0&id=ed47bec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed47bec8",
  null
  
)

export default component.exports